// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pG1j","colMin":"styles_colMin__2Mb5e"};